import { ingestAPIObject } from "../utils/api";
export class Commodity {
    constructor(jsonData) {
        ingestAPIObject(this, jsonData);
    }
}
